import 'bootstrap/dist/css/bootstrap.min.css';

export default function DeleteChaptertModal( {
    show,
    onClose,
    deleteChapter,
    deleteMode,
    setDeleteMode,
    setMoveChapterIndex,
    deleteIndex,
    setRenameMode,
    renameMode,
    project
} ) {
if (!show || deleteIndex === null) return null;
const chapter = project.chapters[deleteIndex];

    return (
         
            <div className="modal fade show d-block" id="DeleteChapterModal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">Potwierdzenie</h5>
                        <button 
                        type="button"
                        className="btn-close"
                        onClick={onClose}>
                        </button>
                    </div>

                    <div className="modal-body">
                        Czy na pewno chcesz usunąć {chapter.title}?
                        {chapter.words > 0 && (
                            <div>
                             <br/> <p> <b> Co chcesz zrobić z słowami z tego rozdziału? </b>  </p>
                            <div> 
                                <input type='radio'
                                value='delete'
                                name='deleteMode'
                                checked={deleteMode === "delete"}
                                onChange={() => setDeleteMode("delete")}> 
                                </input>
                                <label> Usuń całkowicie </label>
                            </div>

                            <div> 
                                <input type='radio'
                                value='move'
                                name='deleteMode'
                                checked={deleteMode === "move"}
                                onChange={()=> setDeleteMode("move")}> 
                                </input>
                                <label> Przenieś do innego rozdziału </label>

                                
                                <select name="chapter"
                                onChange={(e) => setMoveChapterIndex(Number(e.target.value))}>
                                {project.chapters.map((chapter, i) => (
                                    i !== deleteIndex && (
                                        <option key={i} value={i}> {chapter.title} </option>
                                    )
                                ))}
                                </select>
                                
                            </div>
                            
                            </div>
                        )}
                        <div> 
                        <br/> <p> <b>  Po usunięciu, co zrobić z tytułami rozdziałów? </b> </p>
                            <div> 
                                <input type='radio'
                                value='keep'
                                name='renameMode'
                                checked={renameMode === "keep"}
                                onChange={() => setRenameMode("keep")}> 
                                </input>
                                <label> Zachowaj tytuły tak jak są </label>
                            </div>

                            <div> 
                                <input type='radio'
                                value='change'
                                name='renameMode'
                                checked={renameMode === "change"}
                                onChange={() => setRenameMode("change")}> 
                                </input>
                                <label> Automatycznie popraw numeracje </label>
                            </div>

                        </div> 
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                        Anuluj
                        </button>
                        <button className="btn btn-danger"  onClick={()=>{
                            deleteChapter(deleteIndex);
                            onClose(); 
                        }}>
                        Usuń
                        </button>
                    </div>
                </div>
            </div>
            </div>
        
    )
}